/**
 * The type of stream you want to play.
 *
 * @remarks
 * This is used to signal the player what kind of stream it will be dealing with.
 * Depending on the type of stream, we may choose a different player implementation.
 *
 * @privateRemarks
 * Internally we may also use this to change the player behaviour if necessary.
 * e.g. for HLS live streams we have to reload the source when the player was previously paused.
 */
export const StreamType = {
  /**
   * An MPEG-DASH stream.
   *
   * @remarks
   * This is used for most devices to provide ABR streaming.
   *
   * This is used for video content or other content which has to be encrypted.
   */
  DASH: 'DASH',

  /**
   * An HLS stream.
   *
   * @remarks
   * This is used for Apple devices to provide ABR streaming.
   * It is natively only supported on Apple devices.
   *
   * This is used for video content or other content which has to be encrypted.
   */
  HLS: 'HLS',

  /**
   * A progressive stream.
   *
   * @remarks
   * A progressive stream can be anything ranging from a mp3, mp4, webm, ogg, ogv, etc.
   *
   * This is used for content that is not encrypted.
   */
  Progressive: 'Progressive',
} as const;

/**
 * {@inheritDoc StreamType:var}
 */
export type StreamType = (typeof StreamType)[keyof typeof StreamType];
